<template>
  <div>
    <div @click="showModal">
      <i class="fa fa-calendar fa-fw mr-2"></i> Modificar hora
    </div>
    <b-modal ref="my-modal" hide-footer title="Editar hora de parada">
      <div class="d-block text-center">
        <form>
          <div class="d-flex justify-content-center w-100">
            <div class="d-flex flex-column align-items-sm-baseline">
              <label>Hora</label>
              <b-form-input
                type="time"
                v-model="stopHour"
                placeholder="Inserte hora de recogida del guía"
                style="width: 17vw;"
              ></b-form-input>
            </div>
          </div>
        </form>
      </div>
      <div class="mt-3 text-center">
        <b-button pill variant="ligth" @click="hideModal">
          <i class="fa fa-ban mr-1" aria-hidden="true"></i>Cancelar
        </b-button>
        <b-button pill variant="dark" @click="changeHour" class="ml-3">
          <i class="fa fa-floppy-o mr-1" aria-hidden="true"></i>Editar
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "stopTimeModal",
  props: ["id", "hour"],
  data() {
    return {
      stopHour: this.hour
    };
  },
  methods: {
    async changeHour() {
      let payload = {
        id: this.id,
        data: {
          hour: this.stopHour
        }
      };

      try {
        this.$store.dispatch("stops/changeHour", payload);
      } catch (ex) {
        this.error = "Failed to load data";
      } finally {
        this.hideModal();
        this.$notify({
          group: "foo",
          title: "Hora modificada",
          text: "Se ha modificado la hora de la parada",
          type: "info"
        });
        this.$store.dispatch("bookings/loadBookingsByStop");
      }
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    }
  }
};
</script>
